import React, {useState, useEffect} from 'react';
import usePageTitle from "../hooks/usePageTitle";
import {ActualitySection, HeroTitle, ServiceSection} from "../components";
import {HeroShimmer, ServiceShimmer, ActualityShimmer} from "../components/shimmer";
import backgroundImageHome from "../assets/images/background/bg.jpg";
import routes from "../routes/routes";

const Home = () => {
    usePageTitle('Accueil');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 2000);

        return () => clearTimeout(timer);
    }, []);

    if (isLoading) {
        return (
            <div className="flex flex-col">
                <HeroShimmer/>
                <ServiceShimmer/>
                <ActualityShimmer/>
            </div>
        );
    }

    return (
        <div className="flex flex-col">
            <HeroTitle
                title="Bienvenu sur le site officiel de la Commune Urbaine d'Ambalavao"
                description="Découvrez notre histoire, nos projets, et nos richesses culturelles au cœur de la région Haute Matsiatra"
                backgroundImage={backgroundImageHome}
                buttons={[
                    {text: "Présentation", path: routes.township, variant: "primary"},
                    {text: "Actualités", path: "#actualities", variant: "secondary"}
                ]}
            />

            <div className="w-full">
                <ServiceSection/>
            </div>

            <div className="w-full" id="actualities">
                <ActualitySection/>
            </div>
        </div>
    );
};

export default Home;